import { render } from "./SuccessScans.vue?vue&type=template&id=beaff142&scoped=true"
import script from "./SuccessScans.vue?vue&type=script&lang=js"
export * from "./SuccessScans.vue?vue&type=script&lang=js"

import "./SuccessScans.vue?vue&type=style&index=0&id=beaff142&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beaff142"]])

export default __exports__